/**
 * Strips markdown syntax from a string to get plain text.
 * Useful for excerpts.
 */
export const stripMarkdown = (md: string): string => {
	return md
		.replace(/!\[.*?\]\(.*?\)/g, "") // Remove images
		.replace(/\[(.*?)\]\(.*?\)/g, "$1") // Replace links with their text
		.replace(/#{1,6}\s+(.*)/g, "$1") // Remove headers
		.replace(/(\*\*|__)(.*?)\1/g, "$2") // Remove bold
		.replace(/(\*|_)(.*?)\1/g, "$2") // Remove italics
		.replace(/`{3,}[\s\S]*?`{3,}/g, "") // Remove code blocks
		.replace(/`(.+?)`/g, "$1") // Remove inline code
		.replace(/>\s+(.*)/g, "$1") // Remove blockquotes
		.replace(/\n\s*\n/g, " ") // Replace multiple newlines with a space
		.replace(/\n/g, " ") // Replace single newlines with a space
		.trim();
};
